import AppCheckout from '@js/components/checkout/AppCheckout.vue'
import AppRegisterButton from '@js/components/checkout/AppRegisterButton.vue'

const checkoutComponents = [
  AppCheckout,
  AppRegisterButton,
]
export default checkoutComponents
